import React, { useContext, useRef } from 'react';
import { Box } from '@mui/material';
import { UploadedReadedFile } from 'shared/lib/components/controls/uploadArea/uploadArea';
import { UiContext } from 'shared/lib/contexts/uiContext';
import DesktopSmallModal from 'shared/lib/components/modals/desktopSmallModal';
import Cropper, { ReactCropperElement } from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import ButtonsContainer from 'shared/lib/components/controls/buttons/buttonsContainer';
import PrimaryButton from 'shared/lib/components/controls/buttons/primaryButton';

export default function CroppModal({
  src,
  name = 'noname',
  type = 'image/png',
  isOpen,
  handleClose,
  onApply,
}: {
  src: string;
  name?: string;
  type?: string;
  isOpen: boolean;
  handleClose: () => void;
  onApply: (uploadedFile: UploadedReadedFile) => void;
}) {
  const {
    spacings: { sp },
  } = useContext(UiContext);

  const cropperRef = useRef<ReactCropperElement | null>(null);

  const setCropData = () => {
    if (typeof cropperRef.current?.cropper !== 'undefined' && src) {
      cropperRef.current?.cropper.getCroppedCanvas()?.toBlob((blob) => {
        if (blob) {
          const dataUrl = URL.createObjectURL(blob);
          onApply({
            dataUrl: dataUrl,
            originalFile: new File([blob], name, {
              type,
            }),
          });
        }
      });
    }
  };

  return (
    <DesktopSmallModal
      isOpen={!!isOpen}
      handleClose={handleClose}
      disableCloseIcon={true}
      sx={{ overflow: 'hidden' }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: sp.s40,
          overflow: 'hidden',
        }}
      >
        <Cropper
          ref={cropperRef}
          style={{
            minHeight: 400,
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
          }}
          src={src}
          viewMode={1}
          minCropBoxHeight={10}
          minCropBoxWidth={10}
          background={false}
          responsive={true}
          autoCropArea={1}
          checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
          guides={true}
        ></Cropper>

        <ButtonsContainer>
          <PrimaryButton
            onClick={() => {
              setCropData();
              handleClose();
            }}
          >
            Применить
          </PrimaryButton>
        </ButtonsContainer>
      </Box>
    </DesktopSmallModal>
  );
}
